import Marquee from "react-fast-marquee";

const ITEMS = ["WORK CHANGES", "LIFE SHOULDN'T", "ROSTENO"];

export default function MarqueeStrip() {
  return (
    <div
      data-testid="marquee-strip"
      className="border-y border-white/10 py-8 md:py-12 overflow-hidden"
    >
      <Marquee speed={25} gradient={false} pauseOnHover={false}>
        {Array.from({ length: 4 }).map((_, rep) => (
          <div key={rep} className="flex items-center shrink-0">
            {ITEMS.map((item, i) => (
              <span
                key={`${rep}-${item}`}
                className={`font-serif-display text-5xl md:text-7xl lg:text-8xl tracking-tight whitespace-nowrap px-8 ${
                  i % 2 === 0 ? "italic" : "text-outline"
                }`}
              >
                {item}
                <span className="font-mono-accent text-2xl md:text-4xl align-middle px-8 text-[#8B99AE]">
                  —
                </span>
              </span>
            ))}
          </div>
        ))}
      </Marquee>
    </div>
  );
}
